// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".brown-background[data-v-40e917e6]{position:absolute;height:35vw;background-color:var(--bourbon);top:70px;width:100%}.nav-open .brown-background[data-v-40e917e6]{top:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
